module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_3D_Cartoon.e31cab75.png";